import { Box, Button, Typography } from "@mui/material";
import { grey, red } from "@mui/material/colors";

import { Translate } from "@/components/Application/Translate";

type Props = {
	error: unknown;
	componentStack: string;
	reset: () => void;
};

const PageError = ({ error, componentStack, reset }: Props) => {
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				paddingTop: "10%",
				textAlign: "center",
				rowGap: "20px",
				height: "100vh",
				backgroundColor: grey[100],
			}}
		>
			<Typography variant="h1">
				<Translate String="Common.Error.Page">Page Error!</Translate>
			</Typography>
			<Typography variant="h3" component="h2">
				<Translate String="Common.Error.Page.Message">
					Oops! Looks like something went wrong here.
				</Translate>
			</Typography>
			<Typography variant="body1" component="p">
				<Translate String="Common.Error.Page.Details">
					Developer details:
				</Translate>{" "}
				{error?.message}
			</Typography>
			<Box>
				<Button
					variant="contained"
					sx={{ backgroundColor: red[300] }}
					onClick={reset}
				>
					<Translate String="Common.Error.Page.TryAgain">Try again</Translate>
				</Button>
			</Box>
			<Typography variant="body1" component="p">
				<Translate String="Common.Error.Page.Stack">
					If the error persist, please submit a ticket by clicking the button in
					the bottom right corner.
				</Translate>
			</Typography>
		</Box>
	);
};

export default PageError;
